// NPM Imports
import React, { Component } from "react";
import { connect } from "react-redux";
import Modal from "react-responsive-modal";
import DatePicker from "react-datepicker";
import moment from "moment";
import { Button } from "../../../revvComponents";

class DateFilterPopup extends Component {
  state = {
    selectedStartDate: this.props.startDate
      ? moment(this.props.startDate)
      : moment().subtract(7, "days"),
    selectedEndDate: this.props.endDate ? moment(this.props.endDate) : moment(),
    currentDate: moment(),
  };

  // handleChange = selectedDate => {
  //   if (selectedDate !== null) {
  // if (this.props.passDefaultDate) {
  //   this.props.returnValue(selectedDate);
  // } else {
  // this.setState(
  // () => ({ selectedDate }),
  // () => this.props.returnValue(this.state.selectedDate),
  //     );
  //   }
  // };

  handleStartDate = selectedDate => {
    const { selectedEndDate } = this.state;
    if (selectedDate !== null) {
      if (selectedEndDate < selectedDate) {
        this.setState(() => ({ selectedEndDate: selectedDate }));
      }
      this.setState(() => ({ selectedStartDate: selectedDate }));
    }
  };

  handleEndDate = selectedDate => {
    const { selectedStartDate } = this.state;
    if (selectedDate !== null) {
      if (selectedDate < selectedStartDate) {
        this.setState(() => ({ selectedStartDate: selectedDate }));
      }
      this.setState(() => ({ selectedEndDate: selectedDate }));
    }
  };

  startDataSync = () => {
    const { selectedStartDate, selectedEndDate } = this.state;
    const { templateId } = this.props;
    this.props.startDataSync(selectedStartDate, selectedEndDate, templateId);
  };

  render() {
    const { selectedStartDate, selectedEndDate, currentDate } = this.state;
    return (
      <Modal
        open
        onClose={this.props.closePopup}
        closeOnOverlayClick={false}
        center>
        <div
          className="modal-container data-studio-fetch-popup-container"
          data-test="data-studio-fetch-popup-container">
          <div
            className="modal-heading"
            data-test="data-studio-fetch-popup-modal-heading">
            Select date range before syncing
          </div>
          <div className="modal-subheading">
            Only data created during the selected time period will be fetched
          </div>
          <div className="modal-form data-studio-date-picker-wrapper">
            <div>
              <span>Start date</span>
              <DatePicker
                // className={`revvInput_input ${className}`}
                className={`revvInput_input`}
                selected={selectedStartDate}
                onChange={this.handleStartDate}
                disabled={this.props.disabled}
                placeholderText="Start date"
                // minDate={minDate}
                maxDate={currentDate}
                // {...otherProps}
                data-test="dateselect-datepicker-default"
              />
            </div>
            <div>
              <span>End date</span>
              <DatePicker
                label="dsfdsf"
                // className={`revvInput_input ${className}`}
                className={`revvInput_input`}
                selected={selectedEndDate}
                onChange={this.handleEndDate}
                disabled={this.props.disabled}
                placeholderText="End date"
                maxDate={currentDate}
                // minDate={minDate}
                // {...otherProps}
                data-test="dateselect-datepicker-default"
              />
            </div>
          </div>

          <div className="modal-footer">
            <Button
              className="btn btn-transparent modal-footer-btn cancle-btn"
              data-test="data-studio-fetch-popup-cancle-btn"
              onClick={this.props.closePopup}>
              Cancel
            </Button>
            <Button
              type="four"
              className="btn btn-primary modal-footer-btn submit-btn"
              data-test="data-studio-fetch-popup-submit-btn"
              onClick={this.startDataSync}>
              Fetch data
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const {
    template: { id: templateId },
  } = state.TemplateStore;

  return {
    templateId,
  };
};

export default connect(mapStateToProps, null)(DateFilterPopup);
